export const removeTokens = () => {
  sessionStorage.removeItem("token");
  localStorage.clear();
};
export const getAccessToken = () => sessionStorage.getItem("token");

export const setAccessToken = (token: string) =>
  sessionStorage.setItem("token", token);
